import {createSlice} from "@reduxjs/toolkit";

const initialScholarPublicationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  scholarPublicationForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const scholarPublicationsSlice = createSlice({
  name: "scholarPublications",
  initialState: initialScholarPublicationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getScholarPublicationById
    scholarPublicationFetched: (state, action) => {
      state.actionsLoading = false;
      state.scholarPublicationForEdit = action.payload.scholarPublicationForEdit;
      state.error = null;
    },
    // findScholarPublications
    scholarPublicationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createScholarPublication
    scholarPublicationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.scholarPublication);
    },
    // updateScholarPublication
    scholarPublicationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schPublicationId === action.payload.scholarPublication.schPublicationId) {
          return action.payload.scholarPublication;
        }
        return entity;
      });
    },
    // deleteScholarPublication
    scholarPublicationDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schPublicationId !== action.payload.schPublicationId);
    },
    // deleteScholarPublications
    scholarPublicationsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schPublicationId)
      );
    },
  }
});
